import React, { useEffect, useState } from "react";
import MainLayout from "./MainLayout";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TablePagination, TextField, Paper, Button, IconButton, InputAdornment, TableSortLabel, Box
} from "@mui/material";
import * as XLSX from "xlsx";
import { useSelector, useDispatch } from "react-redux";
import TableChartIcon from "@mui/icons-material/TableChart";
import { BlockOutlined, Search } from "@mui/icons-material";
import { skuReport } from "../../redux/slices/projectSlice";
import MultiSelectWithCheckbox from "../utils/MultiSelectWithCheckbox";
import { TableBodySkeleton } from "../utils/TableSkeleton";
import { fetchUserOption } from "../../redux/slices/clientSlice";
import UserService from "../../Services/UserList";
import ExtractAllButton from "../utils/ExtractAllButton";
import DateRangeFilter from "../utils/DateRangeFilter";
import ExtractAllButtonTwo from "../utils/ExtractAllButtonTwo";
import { fetchAdminClient, fetchAdminSku, fetchProductOptions } from "../../redux/slices/adminOptionSlice";
import SkuReportAnalysis from "../utils/SkuReportAnalysis";
import { useLocation } from "react-router-dom";
import { ClickableTableLink } from "./ClickableTableLink";
import MonthFY from "../MonthFY";
import YearFY from "../YearFY";
import FilterBar2 from "./admin_dashboard/FilterBar2";
const roleOpt = [
    { label: "IC", value: 2 },
    { label: "BSP", value: 3 },
    { label: "DSP", value: 4 },
    { label: "BD", value: 5 },
    { label: "Sales Enabler", value: 6 },
    { label: "Dealer", value: 7 },
    { label: "Studio", value: 8 },
];

const FY_YEAR_OPTIONS = [
    { label: "2026-2027", value: "2026" },
    { label: "2025-2026", value: "2025" },
    { label: "2024-2025", value: "2024" },
    { label: "2023-2024", value: "2023" },
];

const ProductLog = () => {
    const TABLE_CONFIG = [
        { label: "SL No.", key: "sl_no", render: (row, idx, page, rowsPerPage) => page * rowsPerPage + idx + 1 },
        {
            label: "SKU Code",
            key: "sku_code",
            render: (row) => (
                <ClickableTableLink
                    path="/admin/product"
                    displayValue={row.sku_code}
                    searchValue={row.sku_code}
                />
            )
        },
        { label: "Description", key: "product_desc" },
        { label: "Category", key: "category", sortable: true },
        { label: "Price Segment", key: "priceSegment", sortable: true },
        { label: "Collection", key: "collection", sortable: true },
        {
            label: "Quotation ID",
            key: "project_id",
            render: (row) => (
                <ClickableTableLink
                    path="/admin/projects"
                    displayValue={row.project_id}
                    searchValue={row.project_id}
                />
            )
        },
        {
            label: "Client Name",
            key: "client_name",
            sortable: true,
            render: (row) => (
                <ClickableTableLink
                    path="/admin/clientlist"
                    displayValue={row.client_name}
                    searchValue={row.client_name}
                />
            )
        },

        { label: "Client's Region", key: "client_region", sortable: true },
        { label: "Client's State", key: "client_state", sortable: true },
        { label: "Channel", key: "user_channel" },
        {
            label: "User Name",
            key: "user_full_name",
            sortable: true,
            render: (row) => (
                <ClickableTableLink
                    path="/admin/userlist"
                    displayValue={`${row.name} ${row.last_name}`}
                    searchValue={row.emp_code || row.name}
                />
            )
        },
        { label: "User's Region", key: "user_region", sortable: true },
        { label: "User's State", key: "user_state", sortable: true },
        {
            label: "Role",
            key: "roleName",
            sortable: true,
            render: (row) => (
                <ClickableTableLink
                    path="/admin/userlist"
                    displayValue={row.roleName}
                    searchValue=""
                    role={roleOpt.find(r => r.label === row.roleName).value}
                />
            )
        },
        { label: "Quantity", key: "total_qty", sortable: true },
        {
            label: "MRP",
            key: "mrp",
            sortable: true,
            // render: (row) => row.mrp !== undefined && row.mrp !== null ? Number(row.mrp).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "N/A"
            render: (row) => {
                const basePrice = Number(row.unit || 0);
                const gstRate = Number(row.gst || 0);
                const calculatedMrp = basePrice > 0 ? basePrice * (1 + gstRate / 100) : Number(row.mrp || 0);
                
                return calculatedMrp !== undefined && calculatedMrp !== null
                ? Number(calculatedMrp).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : "N/A";
            }
        },
        { label: "GST %", key: "gst", sortable: false },
        {
            label: "SKU Total",
            key: "total",
            sortable: true,
            render: (row) => row.total !== undefined && row.total !== null ? Number(row.total).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "N/A"
        },
        {
            label: "Created At",
            key: "created_at",
            sortable: true,
            render: (row) => row.created_at ? new Date(row.created_at).toLocaleString("en-GB") : "N/A"
        },
        {
            label: "Month",
            key: "month",
            sortable: false,
            render: (row) => row.created_at ? new Date(row.created_at).toLocaleString("default", { month: "short" }) : "N/A"
        },
        {
            label: "Year",
            key: "year",
            sortable: false,
            render: (row) => row.created_at ? new Date(row.created_at).getFullYear() : "N/A"
        },
    ];
    const { state: navState } = useLocation();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [channelOpt, setChannelOpt] = useState([]);
    const [selectedChannels, setSelectedChannels] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedClients, setSelectedClients] = useState([]);
    const [selectedCollection, setSelectedCollection] = useState([]);
    const [selectedSegment, setSelectedSegment] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [roleId, setRoleId] = useState([]);
    const [month, setMonth] = useState(() => {
        if (navState && navState.months) return navState.months;
        if (navState && navState.month) return navState.month;

        const fullFYMonths = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
        const currentCalendarMonth = new Date().getMonth() + 1;
        const currentMonthIndex = fullFYMonths.indexOf(currentCalendarMonth);

        return fullFYMonths.slice(0, currentMonthIndex + 1);
    });
    const [year, setYear] = useState(() => {
        const currentYrStr = String(new Date().getFullYear());
        return FY_YEAR_OPTIONS.filter((y) => y.value === currentYrStr);
    });
    const [region, setRegion] = useState([]);
    const [state, setState] = useState([]);
    const [selectedFromDate, setSelectedFromDate] = useState(null);
    const [selectedToDate, setSelectedToDate] = useState(null);
    const [sku, setSku] = useState([]);
    const { userOption } = useSelector((state) => state.client);
    const {
        stats, skuReportData, status, count
    } = useSelector((state) => state.projects);
    const { clientOpt, segmentOpt, collectionOpt,
        categoryOpt, roleOpt, monthOpt, regionOpt, stateOpt, skuOpt
    } = useSelector((state) => state.adminOption);

    useEffect(() => {
        if (navState) {
            if (navState.users?.length > 0 && userOption?.length > 0) {
                const targetDbIds = navState.users.map(id => String(id).trim());

                const matchedUserOptions = userOption
                    .filter((u) => targetDbIds.includes(String(u.id).trim()))
                    .map((u) => ({ value: u.id, label: `${u.name} ${u.last_name}` }));

                setSelectedUsers(matchedUserOptions);
            }
            if (navState.category && categoryOpt.length > 0) {
                setSelectedCategory(categoryOpt.filter((c) => c.value === navState.category || c.label === navState.category));
            }
            if (navState.collection?.length > 0 && collectionOpt.length > 0) {
                setSelectedCollection(collectionOpt.filter((c) => navState.collection.includes(c.value) || navState.collection.includes(c.label)));
            }
            if (navState.priceSegment?.length > 0 && segmentOpt.length > 0) {
                setSelectedSegment(segmentOpt.filter((s) => navState.priceSegment.includes(s.value) || navState.priceSegment.includes(s.label)));
            }
            if (navState.roles?.length > 0 && roleOpt.length > 0) {
                setRoleId(roleOpt.filter((r) => navState.roles.includes(r.value) || navState.roles.includes(r.label)));
            }
            if (navState.regions?.length > 0 && regionOpt.length > 0) {
                const matchedRegions = regionOpt.filter((reg, idx) =>
                    navState.regions.includes(idx) ||
                    navState.regions.includes(idx + 1) ||
                    navState.regions.some(val => String(val).toLowerCase() === reg.value.toLowerCase())
                );
                setRegion(matchedRegions);
            }

            if (navState.states?.length > 0 && stateOpt.length > 0) {
                const matchedStates = stateOpt.filter((st, idx) =>
                    navState.states.includes(idx) ||
                    navState.states.includes(idx + 1) ||
                    navState.states.some(val => String(val).toLowerCase() === st.value.toLowerCase())
                );
                setState(matchedStates);
            }

            if (navState.years?.length > 0) {
                const targetYrs = navState.years.map(String);
                setYear(FY_YEAR_OPTIONS.filter((y) => targetYrs.includes(y.value)));
            }
        }
    }, [navState, userOption, categoryOpt, collectionOpt, segmentOpt, roleOpt, regionOpt, stateOpt, FY_YEAR_OPTIONS]);

    const [sortBy, setSortBy] = useState({ sort_by: "", order: "desc" });

    const counts = count || 0;
    const userOpt = userOption?.map(i => ({ value: i.id, label: `${i.name} ${i.last_name}` })) || [];

    const FILTER_CONFIG = [
        { options: clientOpt, value: selectedClients, onChange: setSelectedClients, placeholder: "Select client", labelKey: "client", width: 200, sorting: true },
        { options: userOpt, value: selectedUsers, onChange: setSelectedUsers, placeholder: "Select users", labelKey: "users", width: 200 },
        { options: skuOpt, value: sku, onChange: setSku, placeholder: "Select sku", labelKey: "product", width: 200 },
        { options: categoryOpt, value: selectedCategory, onChange: setSelectedCategory, placeholder: "Select category", labelKey: "category", width: 200 },
        { options: segmentOpt, value: selectedSegment, onChange: setSelectedSegment, placeholder: "Select segment", labelKey: "segment", width: 200 },
        { options: collectionOpt, value: selectedCollection, onChange: setSelectedCollection, placeholder: "Select collection", labelKey: "collection", width: 200 },
        { options: roleOpt, value: roleId, onChange: setRoleId, placeholder: "Select role", labelKey: "role", width: 180 },
        { options: regionOpt, value: region, onChange: setRegion, placeholder: "Select region", labelKey: "region", width: 180 },
        { options: stateOpt, value: state, onChange: setState, placeholder: "Select state", labelKey: "state", width: 180 },
    ];

    const currentFilters = {
        search: searchTerm,
        from: selectedFromDate || "",
        to: selectedToDate || "",
        user: selectedUsers?.map((u) => u.value)?.join(','),
        sku: sku?.map((u) => u.value)?.join(','),
        client: selectedClients?.map((u) => u.value)?.join(','),
        category: selectedCategory?.map((u) => u.value)?.join(','),
        segment: selectedSegment?.map((u) => u.value)?.join(','),
        collection: selectedCollection?.map((u) => u.value)?.join(','),
        month: month?.map((y) => y).join(','),
        year: year?.map((y) => y.value).join(','),
        region: region?.map((u) => u.value)?.join(','),
        state: state?.map((u) => u.value)?.join(','),
        sort_by: sortBy.sort_by,
        sort_order: sortBy.order,
        role: roleId?.map((u) => u.value)?.join(','),
        channel: selectedChannels?.map((u) => u.value)?.join(','),
    };


    const isUsingDateRange = Boolean(selectedFromDate || selectedToDate);
    const hasValidFilters = isUsingDateRange || Boolean(year?.length > 0 && month?.length > 0);

    const filterConfigs = [
        { id: "client", label: "Client", options: clientOpt || [], selected: selectedClients },
        { id: "user", label: "User", options: userOpt || [], selected: selectedUsers },
        { id: "sku", label: "SKU", options: skuOpt || [], selected: sku },
        { id: "category", label: "Category", options: categoryOpt || [], selected: selectedCategory },
        { id: "segment", label: "Segment", options: segmentOpt || [], selected: selectedSegment },
        { id: "collection", label: "Collection", options: collectionOpt || [], selected: selectedCollection },
        { id: "role", label: "Role", options: roleOpt || [], selected: roleId },
        { id: "channel", label: "Channel", options: channelOpt || [], selected: selectedChannels },
        { id: "region", label: "Region", options: regionOpt || [], selected: region },
        { id: "state", label: "State", options: stateOpt || [], selected: state },
        { id: "year", label: "Year (FY)", options: FY_YEAR_OPTIONS, selected: year },
    ];

    const handleMonthChange = (newMonths) => {
        setMonth(newMonths);
        if (newMonths?.length > 0 && year?.length === 0) {
            const currentYrStr = String(new Date().getFullYear());
            setYear(FY_YEAR_OPTIONS.filter((y) => y.value === currentYrStr));
        }
    };

    const handleFilterChange = (filterId, nextSelected) => {
        switch (filterId) {
            case "client": setSelectedClients(nextSelected); break;
            case "user": setSelectedUsers(nextSelected); break;
            case "sku": setSku(nextSelected); break;
            case "category": setSelectedCategory(nextSelected); break;
            case "segment": setSelectedSegment(nextSelected); break;
            case "collection": setSelectedCollection(nextSelected); break;
            case "role": setRoleId(nextSelected); break;
            case "channel": setSelectedChannels(nextSelected); break;
            case "region": setRegion(nextSelected); break;
            case "state": setState(nextSelected); break;
            case "year":
                setYear(nextSelected);
                if (nextSelected.length === 0) {
                    setMonth([]);
                } else if (month?.length === 0) {
                    const fullFYMonths = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
                    const currentCalendarMonth = new Date().getMonth() + 1;
                    const currentMonthIndex = fullFYMonths.indexOf(currentCalendarMonth);
                    setMonth(fullFYMonths.slice(0, currentMonthIndex + 1));
                }
                break;
            default: break;
        }
    };
    useEffect(() => {
        if (!hasValidFilters) {
            return;
        }
        dispatch(skuReport({ ...currentFilters, page, rowsPerPage }));
    }, [searchTerm, selectedClients, selectedUsers, selectedCategory, selectedSegment, selectedCollection, page, rowsPerPage, selectedFromDate, selectedToDate, month, year, region, state, sortBy, roleId, sku, selectedChannels]);

    const handleDownloadExcel = () => {
        setLoading(true);
        const headers = TABLE_CONFIG.map(col => col.label);
        const data = skuReportData.map((row, idx) =>
            TABLE_CONFIG.map(col => {
                if (col.key === "sl_no") return page * rowsPerPage + idx + 1;
                if (col.key === "created_at") return row.created_at ? new Date(row.created_at).toLocaleString("en-GB") : "N/A";
                if (col.key === "month") return row.created_at ? new Date(row.created_at).toLocaleString("default", { month: "short" }) : "N/A";
                if (col.key === "year") return row.created_at ? new Date(row.created_at).getFullYear() : "N/A";
                if (col.key === "user_full_name") return `${row.name || ""} ${row.last_name || ""}`.trim() || "N/A";
                return row[col.key] || "N/A";
            })
        );
        const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Product Log");
        XLSX.writeFile(wb, "product_log.xlsx");
        setLoading(false);
    };

    const handleSort = (column) => {
        setSortBy(prev => ({
            sort_by: column,
            order: prev.sort_by === column && prev.order === "asc" ? "desc" : "asc"
        }));
    };

    const handleClearFilters = () => {
        setSelectedUsers([]); setSelectedClients([]); setSelectedCategory([]); setSelectedSegment([]); setSelectedCollection([]);
        setSelectedChannels([]); setSku([]);
        setSelectedFromDate(null); setSelectedToDate(null); setSearchTerm(""); setRoleId([]);
        const currentYrStr = String(new Date().getFullYear());
        setYear(FY_YEAR_OPTIONS.filter((y) => y.value === currentYrStr));
        setRegion([]); setState([]);
        const fullFYMonths = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
        const currentCalendarMonth = new Date().getMonth() + 1;
        const currentMonthIndex = fullFYMonths.indexOf(currentCalendarMonth);

        setMonth(fullFYMonths.slice(0, currentMonthIndex + 1));
    };

    useEffect(() => {
        UserService.GetChannels().then(response => {
            if (response && response.data) {
                setChannelOpt(response.data.map(ch => ({
                    value: ch.id,
                    label: ch.channel_name
                })));
            }
        }).catch(console.error);
        dispatch(fetchUserOption());
        dispatch(fetchProductOptions());
        dispatch(fetchAdminClient());
        dispatch(fetchAdminSku());
    }, []);

    return (
        <>
            <MainLayout title={'Quotation Report'} disableScroll={true}>
                <Box sx={{ flexShrink: 0 }}>
                    <SkuReportAnalysis
                        totalQuotation={hasValidFilters ? (stats?.quotationIds || 0) : 0}
                        totalSku={hasValidFilters ? (stats?.sku_codes || 0) : 0}
                        totalUser={hasValidFilters ? (stats?.usernames || 0) : 0}
                        totalClient={hasValidFilters ? (stats?.clients || 0) : 0}
                        totalQty={hasValidFilters ? (stats?.totalQty || 0) : 0}
                        loading={hasValidFilters && (status === 'pending' || status === 'idle')}
                    />
                </Box>
                <Box sx={{ flexShrink: 0 }}>
                    <FilterBar2
                        filters={filterConfigs}
                        onFilterChange={handleFilterChange}
                        selectedMonth={month}
                        setSelectedMonth={handleMonthChange}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        selectedFromDate={selectedFromDate}
                        setSelectedFromDate={setSelectedFromDate}
                        selectedToDate={selectedToDate}
                        setSelectedToDate={setSelectedToDate}
                        onClearFilters={handleClearFilters}
                        actions={
                            <div className="flex items-center gap-2">
                                <Button
                                    variant="contained"
                                    startIcon={<TableChartIcon />}
                                    onClick={handleDownloadExcel}
                                    sx={{
                                        textTransform: "none",
                                        bgcolor: "#2e7d32",
                                        py: '2px',
                                        px: '14px',
                                        borderRadius: 12,
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                        "&:hover": { bgcolor: "#1b5e20" },
                                    }}
                                >
                                    Excel
                                </Button>
                                <ExtractAllButtonTwo
                                    filters={currentFilters}
                                    totalCount={hasValidFilters ? counts : 0}
                                    disabled={!hasValidFilters || counts === 0}
                                />
                            </div>
                        }
                    />
                </Box>

                <Paper elevation={0} sx={{ mt: 2, borderRadius: "12px", overflow: "hidden", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)", flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
                    <TableContainer sx={{ flex: 1, overflow: "auto" }}>
                        <Table stickyHeader id="exceldata" sx={{
                            minWidth: 650,
                            "& .MuiTableHead-root .MuiTableCell-root": {
                                backgroundColor: "#1e293b !important",
                                color: "#f8fafc !important",
                                fontWeight: 600,
                                fontSize: "0.75rem",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em",
                                whiteSpace: "nowrap",
                                borderBottom: "none",
                                py: 2,
                            },
                            "& .MuiTableBody-root .MuiTableRow-root": {
                                transition: "all 0.2s ease-in-out"
                            },
                            "& .MuiTableBody-root .MuiTableRow-root:hover": {
                                backgroundColor: "#f8fafc"
                            },
                            "& .MuiTableCell-root": {
                                borderBottom: "1px solid #e2e8f0",
                                color: "#334155",
                                fontSize: "0.875rem"
                            }
                        }}>
                            <TableHead>
                                <TableRow>
                                    {TABLE_CONFIG.map((col) => (
                                        <TableCell key={col.key} sx={{ fontWeight: "bold", color: "white", whiteSpace: "nowrap" }}>
                                            {col.sortable ? (
                                                <TableSortLabel
                                                    active={sortBy.sort_by === col.key}
                                                    direction={sortBy.sort_by === col.key ? sortBy.order : "desc"}
                                                    onClick={() => handleSort(col.key)}
                                                    hideSortIcon={false}
                                                    sx={{
                                                        color: "white !important",
                                                        cursor: "pointer",
                                                        "& .MuiTableSortLabel-icon": {
                                                            opacity: 1,
                                                            color: "white !important",
                                                        },
                                                    }}
                                                >
                                                    {col.label}
                                                </TableSortLabel>
                                            ) : col.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(() => {
                                    const isUsingDateRange = selectedFromDate || selectedToDate;
                                    const hasValidFilters = isUsingDateRange || (year?.length > 0 && month?.length > 0);
                                    if (!hasValidFilters) {
                                        return (
                                            <TableRow>
                                                <TableCell colSpan={TABLE_CONFIG.length} align="center">
                                                    No data
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }
                                    return status === "pending" ? (
                                        <TableBodySkeleton cols={TABLE_CONFIG.length} rows={10} />
                                    ) : skuReportData?.length > 0 ? (
                                        skuReportData.map((row, idx) => (
                                            <TableRow key={row.id || idx}>
                                                {TABLE_CONFIG.map((col) => (
                                                    <TableCell key={col.key}>
                                                        {col.render ? col.render(row, idx, page, rowsPerPage) : row[col.key] || "N/A"}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={TABLE_CONFIG.length} align="center">
                                                No quotations found
                                            </TableCell>
                                        </TableRow>
                                    );
                                })()}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={hasValidFilters ? [10, 25, 100, counts] : [10, 25, 100]}
                        component="div"
                        count={hasValidFilters ? (counts || 0) : 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={(e, p) => setPage(p)}
                        onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                        sx={{
                            backgroundColor: "#f8fafc",
                            borderTop: "1px solid #e2e8f0",
                            color: "#475569",
                            ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                                fontWeight: 600,
                                fontSize: "0.85rem",
                            }
                        }}
                    />
                </Paper>
            </MainLayout>
        </>
    );
};

export default ProductLog;